import { IUserPerformanceReviewQuery } from '../interfaces/user-performance-review.query.interface';
import { ToDoPerformanceReview } from './todo-performance-review.model';

export class UserToDoPerformanceReview {
    reviews: ToDoPerformanceReview[];
    countOfActiveReviews: number;
    totalCount: number;

    hasOverdueReview: boolean;
    hasNotViewedReview: boolean;
    hasNotVisibleNotViewedReview: boolean;
    hasNotVisibleOverdueReview: boolean;

    constructor(query: IUserPerformanceReviewQuery) {
        this.reviews = query.reviews.map((r) => new ToDoPerformanceReview(r));
        this.countOfActiveReviews = query.count_of_active_reviews;
        this.totalCount = query.total_count;

        this.hasOverdueReview = this.reviews.some((r) => r.isOverdue);
        this.hasNotViewedReview = this.reviews.some((r) => !r.isViewedByOwner);

        this.hasNotVisibleNotViewedReview = this.reviews.slice(2).some((r) => !r.isViewedByOwner);
        this.hasNotVisibleOverdueReview = this.reviews.slice(2).some((r) => r.isOverdue);
    }
}
